import { OptionTypeBase } from '@cad-arc';
import { DispatchAreaObject } from '@mark43/cad-api';

export function toOption(dispatchArea: DispatchAreaObject): OptionTypeBase {
    return {
        label: dispatchArea.name,
        value: dispatchArea.id,
    };
}
